import ImmovoxLogo from "@/components/ImmovoxLogo";
import { motion } from "framer-motion";
import { trackEvent } from "@/lib/analytics";
import type { AdsMode } from "./AdsModeSelector";

const modes: { key: AdsMode; label: string }[] = [
  { key: "vente", label: "Transaction" },
  { key: "location", label: "Gestion locative" },
];

const AdsHeader = ({ mode, onModeChange }: { mode: AdsMode; onModeChange: (m: AdsMode) => void }) => {

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border/50">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <ImmovoxLogo size={28} className="text-primary" />
          <span className="text-lg font-semibold text-foreground">Immovox</span>
        </div>
        <div className="inline-flex items-center rounded-full bg-muted p-1">
          {modes.map((m) => (
            <button
              key={m.key}
              onClick={() => {
                if (m.key !== mode) {
                  onModeChange(m.key);
                  trackEvent("lp_mode_selected", { mode: m.key, source: "header" });
                }
              }}
              className={`relative px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${
                mode === m.key
                  ? "text-primary-foreground"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {mode === m.key && (
                <motion.span
                  layoutId="header-mode-pill"
                  className="absolute inset-0 rounded-full bg-primary shadow-sm"
                  transition={{ type: "spring", stiffness: 500, damping: 35 }}
                />
              )}
              <span className="relative z-10">{m.label}</span>
            </button>
          ))}
        </div>
      </div>
    </header>
  );
};

export default AdsHeader;
